<template>
  <div
    v-bind:style="showAppointments ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Citas :: {{`${dayFormat} de ${schedule_start} a ${schedule_end}`}}</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-row class="form-group">
            <b-col sm="12">
              <b-form class="form form-inline pull-right" @submit.prevent="saveAppointments()">
                <b-row>
                  <b-col>
                    <input type="number" v-model="qty" class="form-control" placeholder="Indique cantidad"/>&nbsp;
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <select v-model="charge_type_id" class="form-control">
                      <option :value="null">Seleccione tipo de carga</option>
                      <option v-for="(charge_type, index) in specialChargeTypes" :key="index" :value="charge_type.id">{{charge_type.name}}</option>
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    &nbsp;<input type="submit" value="Agregar" class="btn btn-primary"/>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="12">
              <h5 v-if="!requeriments.length">No hay citas generadas para este horario</h5>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="12">
              <!-- <div class="table-responsive"> -->
                <table v-if="requeriments.length" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>#RQ</th>
                      <th>Código</th>
                      <!-- <th>Horario de cita</th> -->
                      <th>Tipo de carga</th>
                      <th>Placa</th>
                      <th>Contenedor</th>
                      <th>Conductor</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(requeriment, index) in modalRequeriments" :key="index">
                      <td>{{requeriment.id}}</td>
                      <td>
                        <div v-if="requeriment.charge_type.name !== constants.VACIO" class="input-group mb-3">
                          <input 
                            type="text" 
                            class="form-control" 
                            v-model="codes[index]" 
                          />
                          <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="updateCode(requeriment,codes[index])">Guardar</button>
                          </div>
                        </div>
                        <!-- <button v-if="requeriment.charge_type.name !== constants.GENERAL">Actualizar</button> -->
                        
                        <vue-tags-input
                          v-if="requeriment.charge_type.name === constants.VACIO"
                          :disabled="flag_codes"
                          v-model="text_codes[index]"
                          placeholder="Códigos"
                          :tags="codes[index]"
                          @tags-changed="newTags => editAppointmentCodes(requeriment, newTags)"
                        />
                        <!-- <input type="checkbox" v-model="appointment.multiple"> Citas múltiples -->
                      </td>
                      <!-- <td>
                        {{requeriment.appointments[0].schedule | formatDateTime}}
                      </td> -->
                      <td>
                        <select v-model="requeriment.charge_type_id" class="form-control">
                          <option :value="null">Seleccione tipo de carga</option>
                          <option v-for="(charge_type, index) in specialChargeTypes" :key="index" :value="charge_type.id">{{charge_type.name}}</option>
                        </select>
                      </td>
                      <td>
                        <v-select
                          placeholder="Seleccione camión"
                          label="plate"
                          :options="trucksFiltered"
                          v-model="requeriment.truck"
                          id="select_plate"
                          :disabled="requeriment.truck ? true : false"
                        ></v-select>
                        <!-- {{appointment.requeriment && appointment.requeriment.truck ? appointment.requeriment.truck.plate : '--'}} -->
                      </td>
                      <td>
                        <span v-for="(appointment,k) in requeriment.appointments" :key="k">
                          {{appointment.container ? appointment.container.number : ''}} <span v-if="appointment.container && appointment.container.dead_freight" class="badge badge-danger">Falso flete</span>
                        </span>
                      </td>
                      <td>
                        {{requeriment && requeriment.driver ? `${requeriment.driver.name} ${requeriment.driver.last_name}` : '--'}}
                      </td>
                      <td>
                        {{requeriment.status.name}}
                      </td>
                      <td width=220>
                        <span v-if="![constants.FINALIZADO, constants.ANULADO_TRAMARSA].includes(requeriment.status.code)"><button title="Guardar" @click="edit(requeriment)" class="btn btn-md btn-primary"><i class="fa fa-save fa-lg"/></button>&nbsp;</span>
                        <span v-if="![constants.FINALIZADO, constants.ANULADO_TRAMARSA].includes(requeriment.status.code) && !requeriment.truck"><button title="Eliminar" @click="remove(requeriment)" class="btn btn-danger" ><i class="fa fa-trash fa-lg"/></button>&nbsp;</span>
                        <span v-if="![constants.FINALIZADO, constants.ANULADO_TRAMARSA].includes(requeriment.status.code) && requeriment.truck"><button title="Desasignar" class="btn-warning btn" @click="unassign(requeriment)"><i class="fa fa-close fg-lg"></i></button>&nbsp;</span>
                        <span v-if="![constants.FINALIZADO, constants.ANULADO_TRAMARSA].includes(requeriment.status.code) && requeriment.appointments.some(ap => ap.container_id !== null)"><button title="Falso flete" class="btn btn-danger" @click="deadFreight(requeriment)"><i class="fa fa-random fa-lg"/></button>&nbsp;</span>
                        <span><button title="Logs" class="btn btn-primary" @click="logs(requeriment)"><i class="fa fa-cogs fa-lg"/></button></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              <!-- </div> -->
            </b-col>
          </b-row>
        </div>
        <div class="modal-footer">
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/helpers/api'
import moment from 'moment'
import constants from '@/constants'
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  name: 'ModalEditAppointments',
  components: { VueTagsInput },
  props: [
    'requeriments', 
    'showAppointments', 
    'addAppointments',
    'editAppointment',
    'removeAppointment',
    'port',
    'serviceSelected',
    'appointment_startdate',
    'appointment_enddate',
    'specialChargeTypes',
    'trucks'
  ],
  data(){
    return {
      qty: '',
      constants,
      status: {},
      charge_type_id: null,
      schedule_start: '',
      schedule_end: '',
      dayFormat: '',
      trucksFiltered: [],
      modalRequeriments: [],
      codes: [],
      text_codes: [],
      flag_codes: false
    }
  },
  watch: {
    appointment_startdate: function (newVal, oldVal) {
      this.schedule_start = moment(newVal).format('HH:00');
      this.schedule_end = moment(newVal).format('HH:59');
      this.dayFormat = moment(newVal).locale('es').format('dddd DD, MMMM');
    },
    requeriments: function(newVal, oldVal){
      //NO ACTUALIZA EL ESTADO AL MOMENTO DE ASIGNAR, SI LO MODIFICA CUANDO SE DESASIGNA
      this.modalRequeriments = newVal;
      
      this.modalRequeriments.map((rq,index) => {
        if(rq.charge_type.name !== constants.VACIO){// rq.appointments.length == 1 && rq.appointments[0].code === null) {
          this.codes[index] = rq.appointments[0].code
        } else {
          this.codes[index] = []
          rq.appointments.map(ap => {
            if(ap.code)
              this.codes[index].push({ text: ap.code, tiClasses: ["ti-valid"] })
          })
        }

      })
    },
    trucks: function(trucks, oldVal){
      this.trucksFiltered = trucks.filter(t => t.portage_active)
    }
  },
  mounted(){
    this.constants = constants
    api.get("/statuses").then(response => {
      this.status = response.status;
    });
  },
  methods: {
    updateCode(requeriment, code){
      console.log(code)
      api.put(`/update_code/${requeriment.id}`, {code}).then(response => {
        this.$toastr.success(
          response.message,
          "Cita",
          { positionClass: "toast-top-center", closeButton: true }
        );
        this.$socket.emit("updateAppointmentServer", response.requeriment);
      })
    },
    editAppointmentCodes(requeriment, newTags){
      // requeriment.codes = newTags
      if(newTags.length > 1 && requeriment.charge_type.name !== constants.VACIO){
        this.$toastr.warning(
          "No es posible agregar más de una cita para cargas que no sean VACÍOS.",
          "Cita",
          { positionClass: "toast-top-center", closeButton: true }
        );
        return
      }

      if(!newTags.length){
        this.$toastr.warning(
          "No es posible eliminar la cita. Debes mantener al menos una.",
          "Cita",
          { positionClass: "toast-top-center", closeButton: true }
        );
        return
      }
      let codes = []
      this.flag_codes = true
      newTags.map(nt => codes.push(nt.text))

      const data = {
        codes,
        port_id: this.port.id,
        schedule: this.appointment_startdate,
        service_type_code: this.serviceSelected
      }

      api.post(`/add_codes/${requeriment.id}`, data).then(response => {
        // this.requeriment = response.requeriment
        this.flag_codes = false
        this.$toastr.success(
          response.message,
          "Cita",
          { positionClass: "toast-top-center", closeButton: true }
        );
        this.$socket.emit("updateAppointmentServer", response.requeriment);
      })
      
    },
    logs(requeriment){
      let route = this.$router.resolve({path: `/requeriments/detail/${requeriment.id}`});
      window.open(route.href, '_blank');
    },
    edit(requeriment){
      const { editAppointment } = this
      editAppointment(requeriment)
    },
    deadFreight(requeriment){
      if(confirm('Estas marcado un falso flete, ¿Seguro desea continuar?')){
        // console.log(requeriment)
        api.post(`/dead-freight/${requeriment.id}`, requeriment.appointments).then(response => {
          
          // let index = this.requeriments.findIndex(rq => rq.id === requeriment_id)
          // this.requeriments.splice(1)

          this.$toastr.success(
            "Falso flete registrado exitosamente",
            "Falso flete",
            { positionClass: "toast-top-center", closeButton: true }
          );
        })
      }
    },
    remove(requeriment){
      const { removeAppointment } = this;
      if(confirm('¿Seguro desea eliminar esta cita?')){
        api.delete(`/appointment/${requeriment.id}`).then(response => {
          let index = this.requeriments.findIndex(rq => rq.id === requeriment.id)
          this.requeriments.splice(index, 1)
          this.$socket.emit('removeAppointmentServer', requeriment.id)
          removeAppointment(requeriment)
          this.$toastr.success(
            "Cita eliminada",
            "Cita",
            { positionClass: "toast-top-center", closeButton: true }
          );
        })
      }
    },
    unassign(requeriment){

      const question = `¿Seguro desea desasignar la cita del camión con placa ${requeriment.truck.plate}?`;
      
      if(requeriment.status.code === constants.APROBADO){
        const index = this.requeriments.findIndex(ap => ap.id === requeriment.id)
        this.requeriments[index].truck = null
        this.$toastr.success(
          `Cita desasignada.`,
          "Cita",
          { positionClass: "toast-top-center", closeButton: true }
        );
      } else {
        let status = constants.APROBADO;
        if (requeriment.status.code !== constants.ASIGNADO) {
          status = requeriment.status.code;
        }
        this.updateRq(question, requeriment, status, "desasignada");
      }
    },
    updateRq(question, requeriment, status, label) {
      if (confirm(question)) {
        let data = {
          // FALTA ENVIAR STATUS A REQUERIMIENTO
          status_id: this.status.find(st => st.code === status).id,
          truck_id: null,
          driver_id: null,
          driver_confirm: null
        };
        api.put(`/requeriments/${requeriment.id}`, data).then(response => {

          if (response.success) {
            api
              .post("/action_logs/", {
                rq_id: requeriment.id,
                comments: this.capitalize(label)
              })
              .then(res => console.log(res));

            this.$toastr.success(
              `Cita ${label}.`,
              "Cita",
              { positionClass: "toast-top-center", closeButton: true }
            );
            if (requeriment.driver_id) {
              let data_push = {
                user_id: requeriment.driver_id,
                headings: `Requerimiento ${label}`,
                contents: label,
                data: { requeriment_id: requeriment.id }
              };
              api.post("/send_push", data_push).then(response => {
                // console.log(response);
              });
            }
            this.$socket.emit("updateRequerimentServer", response.requeriment);
          }
          let index = this.requeriments.findIndex(ap => ap.id == requeriment.id)
          this.requeriments[index] = response.requeriment
        });
      }
    },
    saveAppointments(){
      const { 
        addAppointments, 
        qty, 
        port, 
        serviceSelected, 
        appointment_startdate, 
        appointment_enddate,
        charge_type_id } = this;

      const data = {
        qty,
        appointment_startdate,
        appointment_enddate,
        service_type_code: serviceSelected,
        port_id: port.id,
        charge_type_id
      }

      addAppointments(data)
      this.close();
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    close() {
      this.qty = '';
      this.charge_type_id = null;
      this.$emit("close");
    }
  },
  sockets: {
    updateAppointment(data){
      console.log('Llego socket')
      console.log(data)
      let index = this.requeriments.findIndex(rq => rq.id === data.id)
      if(index >= 0){
        this.requeriments.splice(index, 1, data)
      }
    },
    removeAppointment(requeriment_id){
      let index = this.requeriments.findIndex(rq => rq.id === requeriment_id)
      if(index >= 0){
        this.requeriments.splice(index, 1)
      }
    },
    updateRequeriment: function(rq) {
      let index = this.requeriments.findIndex(req => req.id === rq.id);
      if (index >= 0) {
        this.requeriments.splice(index, 1, rq)
      }
    }
  }
}
</script>

<style scoped>
.modal-lg{
  width: 80%;
  max-width: none;
}
#select_plate{ width: 150px; }
</style>


